import { Key } from "react";
import { useSelector } from "react-redux";
import CustomScroll from "react-custom-scroll";
import GoalVideoListItem from "./GoalVideoListItem";
import { goalVideoColumns } from "../admin/helper/multiselectColumns";
import { IObjectKeys, IVideoListDataItem, IChannelData } from "../../constants/interfaces";
import { getLineWidth, getLineSum } from "../admin/helper/lineDistribution";
import { ensureType } from "../../hooks/ensureType";

const MAX_LEGEND_ITEMS = 5;

const VideoListWidget = () => {
	const data = useSelector((state: {goal: {data: {stories: Array<IVideoListDataItem>}}}) => state.goal.data.stories);
	const fields = ["title", "total", "totalWeb", "totalApp"];
	const numberFields = fields.filter(
		(field: string) => !["title"].includes(field)
	);
	const title = "Biggest videos on reach";

	const getFieldTitle = (field: keyof typeof goalVideoColumns) => {
		return goalVideoColumns[field]
	};

	const isLoaded = data && data.length ? true : false;
	if (!data && !isLoaded) return <div>Loading...</div>;
	if (data.length === 0) return <div>Loading...</div>;

	// gather all channel types
	const videoChannels = data.map((p) => p.channels);
	const allChannels: Array<IChannelData> = videoChannels.reduce(
		(p: Array<IChannelData>, n: Array<IChannelData>) => p.concat(n.filter((c) => (c.total || 0) > 0)),
		[]
	);
	const channelLabels = Array.from(
		new Set(allChannels.map((c) => c.label)).values()
	);
	const channelTypes = channelLabels.map((label) => {
		const { color } = ensureType(allChannels.find((e) => e.label === label));
		return { label, color };
	}, {});
	const channelMaxes: IObjectKeys = channelLabels.reduce((store: IObjectKeys, label) => {
		store[label] = Math.max(...allChannels.filter(c => c.label === label).map(c => c.total));
		return store;
	}, {});
	const legendChannels = channelLabels.sort((a, b) => channelMaxes[b] - channelMaxes[a]).slice(0, MAX_LEGEND_ITEMS);
	// List item lines
	const totals = data.map(item => item.total);
	const maxReach = totals.length > 0 ? totals.reduce((a, b) => Math.max(a, b)) : 0;

	return (
		<div
			className={`list-widget ${
				data.length > 10 ? "scroll-enabled" : ""
			}`}
		>
			<div className="list-widget__heading">
				<div className="list-widget__title">{title}</div>
				<div className="list-widget__heading-right">
					<div style={{ flex: 1 }} />
					<ul className="legend">
						{channelTypes.filter(t => legendChannels.includes(t.label)).map((t) => (
							<li
								key={t.label}
								className="legend__item"
								style={{ color: t.color }}
							>
								<span>{t.label}</span>
							</li>
						))}
					</ul>
					{/*{variant === 'full' ? setBrand() : null}*/}
				</div>
			</div>
			<span className="list-widget__extra-info"></span>

			<div className="list-widget__list">
				<div className="list-widget__fields">
					<div className="list-widget__heading-header" />
					{numberFields.map(
						(field: string, index: Key | null | undefined) => (
							<div
								className={`list-widget-stat-heading ${
									field === "pubdate" ? "date" : ""
								}`}
								key={index}
							>
								{getFieldTitle(field as keyof typeof goalVideoColumns)}
							</div>
						)
					)}
				</div>
				<CustomScroll heightRelativeToParent="calc(100% - 55px)">
					{data.map(
						(
							item: IVideoListDataItem,
							key: Key | null | undefined
						) => {
							return (
								<GoalVideoListItem
									key={key}
									data={item}
									lineWidth={getLineWidth(item.total, maxReach)}
									lineSum={getLineSum(item.channels)}
									numberFields={numberFields}
								/>
							);
						}
					)}
				</CustomScroll>
			</div>
		</div>
	);
};

export default VideoListWidget;
